import { atom } from "recoil";

export const applyBaseStylesAppRouterState = atom({
    key: 'applyBaseStylesAppRouter',
    default: true
});